import { Tabs, Tab, Box } from '@mui/material'
import GoogleIcon from '../../../components/icon/GoogleIcon'
import ClientDownloadButton from './ClientDownloadButton'

const ClientTabs = ({
  tabs = [],
  activeTab,
  onChange,
  iconSize = 20,
  filled = false,
  downloadData,
  isDownloadDataFetching,
  clientData,
  startDate,
  endDate
}) => {
  return (
    <Box
      className="d-flex justify-flex-between"
      sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}
    >
      <Tabs
        value={activeTab}
        onChange={(_, value) => onChange(value)}
        textColor="primary"
        indicatorColor="primary"
      >
        {tabs.map((tab) => (
          <Tab
            key={tab.value}
            value={tab.value}
            label={tab.label.toUpperCase()}
            icon={
              tab.icon ? (
                <GoogleIcon
                  name={tab.icon}
                  size={tab.iconSize || iconSize}
                  filled={tab.filled || filled}
                />
              ) : null
            }
            iconPosition="start"
            sx={{
              fontWeight: 600,
              minHeight: 48,
              textTransform: 'none'
            }}
          />
        ))}
      </Tabs>
      {activeTab === 'Perfil 360' && (
        <ClientDownloadButton
          downloadData={downloadData}
          isDownloadDataFetching={isDownloadDataFetching}
          clientData={clientData}
          startDate={startDate}
          endDate={endDate}
        />
      )}
    </Box>
  )
}

export default ClientTabs
